<template>
  <section class="section container">
    <div class="band">
      <h2 class="h2 title">{{ t('closing.title') }}</h2>
      <p class="sub">{{ t('closing.sub') }}</p>
      <PillButton to="/contact" size="lg">{{ t('cta') }}</PillButton>
      <a class="mail" :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
    </div>
  </section>
</template>

<script setup>
import PillButton from './PillButton.vue'
import { useLocale } from '../composables/useLocale'

const { t, contactEmail } = useLocale()
</script>

<style scoped>
.band {
  background: var(--sand);
  border-radius: var(--radius-panel);
  padding: clamp(48px, 8vw, 88px) clamp(24px, 4vw, 56px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

.title {
  font-size: clamp(42px, 7vw, 96px);
  letter-spacing: -0.04em;
  line-height: 1.05;
  max-width: 14ch;
}

.sub {
  font-size: 18px;
  line-height: 1.6;
  color: var(--muted);
  max-width: 44ch;
}

.mail {
  font-size: 16px;
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.mail:hover {
  color: var(--primary-hover);
}
</style>
